module.exports = __webpack_public_path__ + "img/it-declaration-locked.011ca640.png";